import React, { forwardRef, MutableRefObject } from 'react';
import { InputBase } from 'component-library';
import { IInputProps } from 'component-library/atoms/InputBase/InputBase';

const InputPhone = forwardRef(
	(
		{ className = '', value, setValue, mask = '000-000-0000', maxLength = 10, ...rest }: IInputProps,
		ref: MutableRefObject<HTMLInputElement> | any,
	) => {
		const getRawVal = (phone) => {
			const rawVal = phone?.replace(/[^0-9]/g, '');
			return rawVal;
		};

		const isPhoneValid = (val) => {
			const cleanVal = getRawVal(val);
			return !(cleanVal.length >= 1 && cleanVal.length < maxLength);
		};

		return (
			<InputBase
				{...rest}
				type='tel'
				mask={mask}
				maxLength={maxLength}
				className={`InputPhone ${className}`}
				isValid={isPhoneValid}
				value={value}
				ref={ref}
				setValue={(phone) => {
					setValue(phone);
				}}
			/>
		);
	},
);

InputPhone.displayName = 'InputPhone';

export default InputPhone;
